import {setCheckOutReducers} from '../reducers/setCheckOutReducers.js';

// Actions
export const getCheckOutAction = (data) => async dispatch => {
    try {
        dispatch(setCheckOutReducers(data));
    } catch (e) {
        console.error('user get Error Action',e.message);
    }
};